/* eslint-disable no-lonely-if */
/* eslint-disable camelcase */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect, useState } from 'react';
import { LiMultiterm } from 'lisecutilityfunctions/lib/utilitylib';
import { FlexboxContainer, FlexboxItem, Dropdown } from 'ui-components';
import {
    patchCustomerProduct,
    putCustomerProduct,
    postCustomerProductHardlocks,
    deleteCustomerProductHardlocks
} from '../../slice/index';
import { ICustomerProductsHardlock } from '../../../../@types/customers';
import { useAppDispatch } from '../../../../hooks';
import { CM_CLIENT_v2_2 } from '../../../../utils/appConstants';
import { getVersions } from '../../../../api/versionNegotiationHelpers';

interface IHardlockProductionSitesAccordion {
    customerProducts: Array<number>;
    allCustomerProducts: Array<ICustomerProductsHardlock>;
    hardlockId: number;
}

const HardlockProductionSitesAccordion = ({
    customerProducts,
    allCustomerProducts,
    hardlockId
}: IHardlockProductionSitesAccordion) => {
    const dispatch = useAppDispatch();
    const [dropdownItems, setDropdownItems] = useState<Array<any>>([]);
    const generateCustomersProductsDropdown = (customers: Array<any>, customerProduct: any) => {
        const selectedCustomerProducts = JSON.parse(JSON.stringify(customerProduct));
        selectedCustomerProducts?.forEach((products: any) => {
            products.name = `${products.productId} - ${products.productName} ${products.productVersionVerison}`;
            products.checked = customers.includes(products.id);
        });
        setDropdownItems(selectedCustomerProducts);
    };

    useEffect(() => {
        generateCustomersProductsDropdown(customerProducts, allCustomerProducts);
    }, [customerProducts]);

    /**
     * @function onUnassignProductsToHardlock
     * @param previouslySelected
     * @param selectedProduct
     * @param clientFileVersion
     * @description Executes when un-checked(deselect) from dropdown to unassign product
     * @description use API deleteCustomerProductHardlocks when client version >= 2.2, putCustomerProduct otherwise.
     */
    const onUnassignProductsToHardlock = (
        previouslySelected: Array<any>,
        selectedProduct: Array<ICustomerProductsHardlock>,
        clientFileVersion: string
    ) => {
        const deSelectedItem = previouslySelected.filter(
            (elem: { id: number; productVersionVerison: string }) =>
                !selectedProduct.find(
                    (product) => elem.id === product.id && elem.productVersionVerison === product.productVersionVerison
                )
        );

        if (clientFileVersion >= CM_CLIENT_v2_2) {
            const customerProduct = {
                customerProductIds: [deSelectedItem[0]?.id],
                hardlockId
            };
            dispatch(
                deleteCustomerProductHardlocks({
                    body: customerProduct,
                    productionSiteId: deSelectedItem[0]?.productionSiteId
                })
            );
        } else {
            const customerProduct = {
                productionSiteId: deSelectedItem[0]?.productionSiteId,
                productVersionId: deSelectedItem[0]?.productVersionId,
                hardlockId: null,
                modified: deSelectedItem[0].modified
            };
            const customerProductId = deSelectedItem[0]?.id;
            dispatch(putCustomerProduct({ body: customerProduct, customerProductId }));
        }
    };

    /**
     * @function onAssignProductsToHardlock
     * @param selectedCustomerProduct
     * @param clientFileVersion
     * @description Executes when check marked from dropdown to assign product
     * @description use API postCustomerProductHardlocks when client version >= 2.2, patchCustomerProduct otherwise.
     */
    const onAssignProductsToHardlock = (selectedCustomerProduct: Array<any>, clientFileVersion: string) => {
        if (clientFileVersion >= CM_CLIENT_v2_2) {
            const customerProduct = {
                customerProductIds: [selectedCustomerProduct[0]?.id],
                hardlockId
            };
            dispatch(
                postCustomerProductHardlocks({
                    body: customerProduct,
                    productionSiteId: selectedCustomerProduct[0]?.productionSiteId
                })
            );
        } else {
            const customerProduct = {
                productionSiteId: selectedCustomerProduct[0]?.productionSiteId,
                productVersionId: selectedCustomerProduct[0]?.productVersionId,
                hardlockId,
                modified: selectedCustomerProduct[0].modified
            };
            const customerProductId = selectedCustomerProduct[0]?.id;
            dispatch(patchCustomerProduct({ body: customerProduct, customerProductId }));
        }
    };

    /**
     * OnSelect and Deselect of customerProducts change
     * @param selectedProduct
     */
    const onCustomerProductChange = async (selectedProduct: Array<ICustomerProductsHardlock>) => {
        const previouslySelected = dropdownItems.filter((item: any) => item.checked);
        const clientFileVersion = await getVersions();
        const ID = 'id';
        const uniqueCustomerProducts = [...new Map(selectedProduct.map((item) => [item[ID], item])).values()];

        const selectedCustomerProduct =
            customerProducts?.length >= 1
                ? uniqueCustomerProducts?.filter(
                      (product: ICustomerProductsHardlock) => !customerProducts.includes(product.id)
                  )
                : uniqueCustomerProducts;
        // While remove / unassigning products from hardlock
        if (previouslySelected.length > selectedProduct.length) {
            onUnassignProductsToHardlock(previouslySelected, selectedProduct, clientFileVersion);
        } else {
            // While add / assigning products to hardlock
            onAssignProductsToHardlock(selectedCustomerProduct, clientFileVersion);
        }
    };

    return (
        <FlexboxContainer
            flexDirection="column"
            gap="1rem"
            className="Accordion_wrapper Full_width"
            justifyContent="start"
            alignItems="stretch"
        >
            <FlexboxItem className="Full_width">
                <FlexboxItem className="Half_width">
                    <Dropdown
                        changeSelected={onCustomerProductChange}
                        dropdownItems={dropdownItems}
                        multiSelectable
                        required
                        theme="light"
                        title={<LiMultiterm textId="99034264" textVal="Assigned products" />}
                    />
                </FlexboxItem>
            </FlexboxItem>
        </FlexboxContainer>
    );
};

export default HardlockProductionSitesAccordion;
